"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../../shapes/ShapeLoop");
/**
 * Polygon shape
 *
 * @category Shapes.ShapeLoop
 * @class Polygon
 * @extends {ShapeLoop}
 */
class Star extends ShapeLoop_1.ShapeLoop {
    /**
     * Is based on ShapeLoop and you can pass `spikes` property to define
     * a number of spikes and `innerRadius`
     *
     * @param settings
     */
    constructor(settings = {}) {
        settings.type = settings.type || 'Polygon';
        settings.loopDependencies = (settings.loopDependencies || []).concat(['spikes', 'innerRadius']);
        super(settings, true);
        this.props.spikes = settings.spikes;
        this.props.innerRadius = settings.innerRadius;
        this.loop = {
            start: 0,
            end: math_1.PI2,
            inc: (propArguments) => {
                // dyamic binding in `generateLoopBuffer`
                return this.inc;
            },
            vertex: shapeLoopRepetition => {
                const angle = (Math.PI / this.spikes) * shapeLoopRepetition.index;
                const radius = shapeLoopRepetition.index % 2 === 0 ? 1 : this.innerRadius;
                return [Math.cos(angle) * radius, Math.sin(angle) * radius];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    generateLoopBuffer(propArguments) {
        this.spikes = this.getProp('spikes', propArguments, 5);
        this.innerRadius = this.getProp('innerRadius', propArguments, 0.5);
        this.inc = Math.PI / this.spikes;
        return super.generateLoopBuffer(propArguments);
    }
}
exports.Star = Star;
//# sourceMappingURL=Star.js.map